import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=1d6f088a&class=full-heigth&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"
import style0 from "./couponList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6f088a')) {
      api.createRecord('1d6f088a', component.options)
    } else {
      api.reload('1d6f088a', component.options)
    }
    module.hot.accept("./couponList.vue?vue&type=template&id=1d6f088a&class=full-heigth&", function () {
      api.rerender('1d6f088a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/components/couponList.vue"
export default component.exports